// Exact UI action labels, expanded from shared nouns during localization.
export const actionEnglish: Record<string,string> = {
  '当天录音统计': 'Daily recording metrics',
  '人声存储 {size}': 'Speech storage {size}',
  '转写 {count} 字': 'Transcript {count} characters',
  '（已确认）': ' (confirmed)',
  '处理中，统计待更新': 'Processing; metrics will update',
  '部分大小暂不可确认': 'Some archive sizes are not yet confirmed',
  '人声存储仅统计归属于本人的录音，不包含原始文件或转写切片，跨日主档不估算分摊；字数按当天最终转写去除空白后计算。': 'Speech storage includes only recordings attributed to you, excluding source files and transcript slices. Cross-day archive sizes are not prorated. Character counts exclude whitespace in the final daily transcript.',
  'Codex 任务列表': 'Codex tasks',
  'Codex 对话阅读区': 'Codex conversation',
  '任务对话记录': 'Task conversation',
  '返回任务列表': 'Back to tasks',
  '任务信息与操作': 'Task information and actions',
  '只读同步': 'Read-only sync',
  '选择一项任务，继续阅读对话': 'Select a task to read the conversation',
  '按成员和项目查看已同步的输入与回答': 'Browse synced requests and responses by member and project',
  '仅显示已同步的输入与回答，不包含工具过程。': 'Shows synced requests and responses, not tool execution details.',
  '图片未同步': 'Image not synced',
  '代码': 'Code',
  '复制代码': 'Copy code',
  '复制输入': 'Copy request',
  '复制回答': 'Copy response',
  '复制失败，请手动选择文本': 'Copy failed. Please select the text manually.',
  '等待同步本轮回答…': 'Waiting for this response to sync…',
  '有新内容 ↓': 'New content ↓',
  '回到最新 ↓': 'Jump to latest ↓',
  '工作动态': 'Work activity',
  '同步管理': 'Sync settings',
  'Codex 同步管理': 'Codex sync settings',
  'Codex 同步': 'Codex sync',
  '团队功能': 'Team features',
  '查看团队对话': 'Team conversations',
  '查看对话': 'View conversations',
  '查看 {name} 的 Codex 对话': 'View {name}’s Codex conversations',
  '在团队中选择成员或管理同步，对话统一在这里查看。': 'Choose members or manage sync in Teams. Read all conversations here.',
  '暂时无法核对这位成员的云端身份，请刷新团队后重试': 'Could not verify this member’s cloud identity. Refresh the team and try again.',
  '当前团队尚不支持查看其他成员的云端对话': 'Cloud conversations from other members are not available for this team yet.',
  '当前请求': 'Current request',
  '队列同步已暂停': 'Queue sync paused',
  '队列暂不可读': 'Queue unavailable',
  '队列不完整': 'Queue incomplete',
  '队列状态待更新': 'Queue awaiting refresh',
  '待处理 {count} 条': '{count} pending requests',
  '排队 {count} 条': '{count} queued requests',
  '{count} 条排队消息': '{count} queued messages',
  '上次队列 {count} 条': '{count} items in last queue snapshot',
  '暂无排队请求': 'No queued requests',
  '发送结果待确认': 'Send outcome unknown',
  '正在发送': 'Sending',
  '等待继续': 'Waiting to resume',
  '待发送': 'Pending send',
  '排队中': 'Queued',
  '无文本输入': 'No text input',
  '只读本机快照；运行状态以 Codex 为准': 'Read-only local snapshot. Check Codex for live execution status.',
  '检查于 {time}': 'Checked {time}',
  '以下保留上次可读取的内容，数量和顺序可能不完整。': 'Last readable content retained below. Count and order may be incomplete.',
  '排队请求': 'Queued requests',
  '{count} 个附件': '{count} attachments',
  '正文已截断': 'Text truncated',
  '收起队列': 'Collapse queue',
  '展开其余 {count} 条': 'Show {count} more',
  '历史输入输出': 'Input and response history',
  '采集本机新输入、每轮回答，以及已接入对话的当前排队请求；不补采历史，暂不包含远程和云端任务。': 'Collects new local inputs, final responses and current queues for connected chats. No history import, remote or cloud tasks.',
  '队列为只读兼容预览；尚未产生接入事件的新对话，要在首次开始执行后才能关联。': 'Read-only compatibility preview. A new chat is associated after its first connected event when execution begins.',
  '接入本机 Codex': 'Connect this Codex',
  '本机 Codex': 'Local Codex',
  '任意对话接入一次，后续任务自动同步': 'Connect once in any chat. Future tasks sync automatically.',
  '自动同步本机全部项目（排除项除外）': 'Syncing all local projects, except exclusions',
  '本机同步已暂停': 'Local sync paused',
  '已配置，等待 Codex 真实事件': 'Configured. Waiting for a real Codex event.',
  '等待一次性接入本机 Codex': 'Waiting for one-time Codex setup',
  '已配置；请在 Codex 检查 Hooks 信任状态': 'Configured. Check hook trust in Codex.',
  '首次接入有效至 {time}': 'Initial setup valid until {time}',
  '管理连接': 'Manage connection',
  '未归属项目': 'Unassigned project',
  '旧版单任务记录': 'Legacy single-task activity',
  '已排除': 'Excluded',
  '排除此项目': 'Exclude project',
  '恢复此项目': 'Include project',
  '排除此任务': 'Exclude task',
  '恢复此任务': 'Include task',
  '筛选项目': 'Filter projects',
  '全部项目': 'All projects',
  '搜索任务或项目': 'Search tasks or projects',
  '没有匹配的任务': 'No matching tasks',
  '显示更多任务': 'Show more tasks',
  '此项目已排除；恢复单项任务不会恢复项目同步。': 'This project is excluded. Including a task does not include the project.',
  '仅采集这份 Codex 配置的新输入和每轮回答；历史不补采，远程和云端任务不包含在内。': 'Only new inputs and final responses from this local Codex configuration are collected. No history, remote or cloud tasks.',
  '一次接入，在这里按项目查看各任务的新输入、回答和状态。当前不会分享给其他成员。': 'Connect once to see new task inputs, responses and status by project. Nothing is shared with other members.',
  '团队视图': 'Team view',
  '接入我的 Codex': 'Connect my Codex',
  '我的 Codex': 'My Codex',
  '本机试用 · 仅自己可见': 'Local preview · Only you can see this',
  '接入 Codex 任务': 'Connect a Codex task',
  '等待接入确认': 'Waiting for connection',
  '接入指令已过期': 'Connection instructions expired',
  '本轮结束': 'Turn ended',
  '工作动态加载失败，请重试': 'Could not load activity. Please retry.',
  '加载更早记录': 'Load earlier activity',
  '收到这项任务的新输入或回答后，会显示在这里。': 'New inputs and responses from this task will appear here.',
  '我的输入': 'My input',
  'Codex 回答': 'Codex response',
  '任务已中断': 'Task interrupted',
  '本轮已结束，未收到回答文本。': 'The turn ended without response text.',
  '内容过长，仅保留前 65,536 个字符。完整内容请在 Codex 查看。': 'Only the first 65,536 characters are saved. View the full text in Codex.',
  '无法自动复制，请选中下方接入指令手动复制。': 'Copy failed. Select and copy the instructions below manually.',
  'Codex 接入指令': 'Codex connection instructions',
  '只同步粘贴指令的任务': 'Only sync the task where you paste these instructions',
  '先审查本机脚本，再在 Codex 确认信任 Hooks。收到真实事件后才显示已连接。': 'Review the local script and trust its hooks in Codex. Connection is confirmed only after a real event arrives.',
  '需本机安装 Python 3；保持 Arkme 运行并登录当前账号。接入后不读取历史聊天。': 'Requires local Python 3. Keep Arkme running with this account signed in. Past chats are not imported.',
  '有效至 {time}': 'Valid until {time}',
  '复制接入指令': 'Copy connection instructions',
  '正在加载工作动态…': 'Loading work activity…',
  '把正在做的事留在团队里': 'Keep your work in view',
  '接入一个 Codex 任务后，在这里查看你的输入、每轮回答和运行状态。当前不会分享给其他成员。': 'Connect a Codex task to see your inputs, responses and status. Nothing is shared with other members in this local preview.',
  '暂停同步': 'Pause sync',
  '恢复同步': 'Resume sync',
  '断开连接': 'Disconnect',
  '删除本地记录': 'Delete local activity',
  '停止同步并删除这项任务的本地记录？无法撤销，不会删除 Codex 原任务。': 'Stop syncing and permanently delete this local activity? The original Codex task will not be deleted.',
  '断开后保留已有记录，后续需重新接入。确定断开？': 'Keep existing activity and disconnect? Reconnection requires new instructions.',
  '加载更多说话人': 'Load more speakers',
  '该分类暂无说话人': 'No speakers in this category',
  '没有匹配的说话人': 'No matching speakers',
  '目录有更新，刷新后查看最新人物。': 'The directory has updates. Refresh to see the latest people.',
  '搜索内容过长，请缩短至 256 字节以内。': 'Search text is too long. Keep it within 256 bytes.',
  '搜索名称或编号': 'Search by name or number',
  '查看状态暂未同步，联网后自动重试。': 'View status has not synced. It will retry when online.',
  '正在加载人物详情…': 'Loading person details…',
  '部分录音仍在整理，人物可能继续更新。': 'Some recordings are still being processed. People may continue to update.',
  '正在更新，当前显示已整理的目录。': 'Updating. Showing the available directory.',
  '更新暂未完成，当前显示上次整理的目录。': 'The update has not completed. Showing the previous directory.',
  '正在整理说话人目录…': 'Preparing the speaker directory…',
  '说话人目录暂不可用，请稍后刷新。': 'The speaker directory is unavailable. Please refresh later.',
  '说话人目录暂不可用，请稍后再试。': 'The speaker directory is unavailable. Please try again later.',
  '声纹状态暂不可用': 'Voiceprint status unavailable',
  '暂时无法更新': 'Unable to update',
  '目录暂不可用': 'Directory unavailable',
  '发现未发布的草稿': 'Unpublished draft found',
  '草稿预览': 'Draft preview',
  '预览草稿': 'Preview draft',
  '关闭草稿预览': 'Close draft preview',
  '关闭草稿恢复弹窗': 'Close draft recovery dialog',
  '保存时间：': 'Saved at: ',
  '保存时间未知': 'Save time unavailable',
  '编辑原文': 'Edit original',
  '恢复草稿': 'Restore draft',
  '群聊提及': 'Group mention',
  '群内原消息的已读状态暂不可用': 'Read status of the original group message is unavailable',
  '对方已阅读群内原消息': 'They have read the original group message',
  '对方尚未阅读群内原消息': 'They have not read the original group message',
  '你已阅读群内原消息': 'You have read the original group message',
  '你尚未阅读群内原消息': 'You have not read the original group message',
  '绑定邮箱': 'Bind email',
  '请输入邮箱地址': 'Enter your email address',
  '请输入有效的邮箱地址': 'Enter a valid email address',
  '请输入4位邮箱验证码': 'Enter the 4-digit email code',
  '验证码已发送，请查收邮箱': 'Code sent. Check your inbox.',
  '邮箱已绑定，正在刷新账号信息；刷新失败时可重试。': 'Email bound. Refreshing account details; you can retry if this fails.',
  '刷新账号信息': 'Refresh account details',
  '邮箱绑定成功': 'Email bound successfully',
  '该邮箱已绑定其他账号': 'This email is already linked to another account',
  '当前账号已绑定邮箱，请刷新账号信息': 'This account already has an email. Refresh account details.',
  '邮箱或验证码错误': 'Incorrect email or verification code',
  '邮箱绑定响应异常，请重试': 'Unexpected email binding response. Please try again.',
  '注销账号': 'Delete account',
  '正在检查…': 'Checking…',
  '注销方式已变化，请重新确认': 'The deletion method has changed. Please confirm again.',
  '无需等待，将立即注销。注销完成后无法恢复登录。': 'Your account will be deleted immediately. You cannot sign back in after deletion.',
  '账号将在 15 天等待期结束后注销，期间继续登录可撤销注销。': 'Your account will be deleted after 15 days. Signing in during this period cancels the request.',
  '申请成功、剩余 5 天及剩余 1 天时，将向绑定手机号发送短信提醒。': 'We will send SMS reminders when you submit the request, with 5 days left, and with 1 day left.',
  '请输入“确认注销”': 'Type “确认注销” to confirm',
  '确认注销': 'Confirm deletion',
  '正在处理…': 'Processing…',

  '共同群聊': 'Shared groups',
  '调整共同群聊宽度': 'Resize shared groups',
  '同步尚未完成，请继续同步': 'Sync is incomplete. Continue syncing.',
  '暂时无法打开群聊，请重试': 'Could not open this group. Try again.',
  '第 {v0} 页': 'Page {v0}',
  '暂时无法读取共同群聊，请重试': 'Could not read shared groups. Try again.',
  '正在获取共同群聊…': 'Loading shared groups…',
  '暂无共同群聊': 'No shared groups',
  '共同群聊读取失败': 'Could not read shared groups',
  '正在同步…': 'Syncing…',

  '账号已切换，无法保存；请保留窗口或复制内容后再关闭': 'Account changed. Keep this window open or copy the content before closing.',
  '发送到：': 'Send to: ',
  '草稿已保存': 'Draft saved',
  '正在保存草稿…': 'Saving draft…',
  '草稿保存失败，请重试': 'Could not save draft. Please retry.',
  '未保存': 'Not saved',
  '保留这篇长文的修改？': 'Keep changes to this article?',
  '保存草稿后，可以下次继续编辑。': 'Save a draft to continue editing later.',
  '保存并关闭': 'Save and close',
  '是否暂存草稿': 'Save a draft?',
  '保存草稿': 'Save draft',
  '确认修改': 'Confirm changes',
  '关闭草稿确认弹窗': 'Close draft confirmation',
  '放弃修改': 'Discard changes',

  "关闭用量与额度详情": "Close usage and limits details",
  "所属会话：": "Conversation: ",
  "保存修改": "Save changes",
  "只读": "Read only",
  "关闭添加长文": "Close add an article",
  "关闭充值弹窗": "Close add credit",
  "关闭日历": "Close calendar",
  "关闭当天内容": "Close this day's content",
  "关闭通话详情": "Close call details",
  "返回联系人与通话入口": "Back to contacts & calls",
  "打开联系人与通话入口": "Open contacts & calls",
  "返回联系人选择": "Back to contact selection",
  "关闭通话邀请": "Close call invitation",
  "关闭联系人选择": "Close contact selection",
  "关闭通话引导": "Close call tour",
  "关闭录像": "Close video recording",
  "关闭成员快记": "Close member notes",
  "关闭聊天预览": "Close chat preview",
  "关闭二维码识别": "Close qR code scanner",
  "关闭聊天搜索": "Close chat search",
  "关闭我的一天": "Close my day",
  "关闭活动详情": "Close activity details",
  "关闭回复列表": "Close replies",
  "关闭分享弹窗": "Close share",
  "关闭文件预览": "Close file preview",
  "关闭群成员": "Close group members",
  "返回规则列表": "Back to rules",
  "关闭禁止加入名单": "Close blocked members",
  "查看群成员": "View group members",
  "关闭功能引导": "Close feature tour",
  "关闭长文": "Close articles",
  "关闭扩展详情": "Close extension details",
  "关闭市集": "Close marketplace",
  "关闭会员窗口": "Close membership dialog",
  "关闭转发对象选择": "Close forwarding destinations",
  "关闭举报": "Close report",
  "关闭快记详情": "Close note details",
  "返回快记详情": "Back to note details",
  "返回相关快记列表": "Back to related notes list",
  "关闭插件更新": "Close extension updates",
  "关闭录音体验": "Close recording tour",
  "关闭预览": "Close preview",
  "关闭截图": "Close screenshot",
  "关闭全局搜索": "Close search everywhere",
  "返回搜索": "Back to search",
  "关闭发给自己引导": "Close saved notes tour",
  "关闭添加联系人": "Close add contact",
  "关闭指定主题": "Close choose topic",
  "关闭主题": "Close topics",
  "关闭登录": "Close sign in",
  "关闭图片预览": "Close image preview",
  "关闭发布窗口": "Close post dialog",
  "关闭上传文件": "Close upload files",
  "关闭已完成": "Close completed",
  "关闭录音引导": "Close recording guide",
  "关闭说话人编辑": "Close speaker editor",
  "关闭当前窗口说话人统计": "Close speaker statistics for this range",
  "关闭转写对比": "Close compare transcripts",
  "返回转发对象": "Back to forwarding destination",
  "关闭录音转发": "Close forward recording",
  "关闭工作区选择": "Close workspace picker",
  "关闭修改备注": "Close edit contact name",
  "关闭相关录音": "Close related recordings",
  "关闭录音详情": "Close recording details",
  "团队云端工作动态": "Team cloud activity",
  "此会话曾关联不同账号或团队，暂不上传云端。": "This conversation has multiple account or team bindings. Cloud upload is blocked.",
  "部分任务存在跨账号归属冲突，仅保留在本机，未继续上传。": "Some tasks have conflicting account bindings. They remain local and are not uploaded.",
  "云端可读 · 本机尚未开启上传": "Cloud records available · Uploads from this computer are off",
  "开启云端同步": "Enable cloud sync",
  "确认开启云端同步": "Confirm cloud sync",
  "来源名称": "Source name",
  "来源名称需为 1–128 字节，且不能包含控制字符": "Use a source name of 1–128 UTF-8 bytes without control characters.",
  "真实接入后登记来源，方便同账号在其他电脑显示 Codex 入口；不自动读取电脑名称。已有来源保留原名称。": "After a verified connection, register this source so your account can show Codex on other computers. Your computer name is not read automatically. Existing sources keep their original names.",
  "停止云端上传（保留本机采集）": "Stop cloud uploads (keep local collection)",
  "将当前账号在即我团队下未暂停、未排除的本地记录及后续输入输出上传，团队成员可见。排队请求暂不上云。": "Upload this account's existing and future inputs and outputs bound to the Jiwo team, except paused or excluded records. Team members can see them. Queued requests stay local.",
  "搜索仅筛选当前页已加载的任务": "Search filters tasks loaded on this page only",
  "本机工作动态": "Local activity",
  "排队请求暂仅在来源电脑可见": "Queued requests are only available on the source computer",
  "用户输入": "User input",
  "正文已截断；完整内容请在来源电脑的 Codex 查看。": "Text is truncated. View the full content in Codex on the source computer.",
  "停止同步并删除这项任务的本地记录？无法撤销，不会删除 Codex 原任务或已上传的云端记录。": "Stop syncing and permanently delete this local record? The original Codex task and uploaded cloud records will remain.",
  "已连接团队云端 · 待上传 {count} 条": "Connected to team cloud · {count} pending uploads",
  "需处理 {count} 条": "{count} items need attention",
  "指定团队中未暂停、未排除的已有记录及后续输入输出会同步到云端，团队成员可见；排队请求、Token 用量暂不上传。删除本地记录不会删除云端副本。": "Existing and future inputs and outputs in the designated team are shared with team members unless paused or excluded. Queued requests and token usage are not uploaded. Deleting local records does not delete cloud copies.",
  "接入本机后自动同步；其他电脑登录同一账号即可查看团队云端工作动态。": "Connect this computer to sync automatically. Sign in on another computer to view team cloud activity.",
  "当前团队仅保留本机记录；本次云端试用仅面向即我团队。": "This team keeps local records only. Cloud sync is currently available only for the Jiwo team.",
  "云端同步已停止，请检查账号、团队权限或上传数据。": "Cloud sync stopped. Check the account, team permissions or upload data.",
  "云端暂不可用，本地记录已保留，将自动重试。": "Cloud is temporarily unavailable. Local records are safe; retrying automatically.",
  "部分记录存在版本冲突或被拒绝，已保留本地内容，未覆盖云端。": "Some records conflicted or were rejected. Local content is retained; cloud content was not overwritten.",
  "正在确认…": "Checking…",
  "等待接入": "Not connected",
  "仅本机采集": "Local collection only",
  "暂无法核验云端状态": "Cloud status could not be verified",
  "未开启 · 仅查看云端记录": "Off · Cloud records are read-only",
  "已开启 · 需处理 {count} 条": "Enabled · {count} items need attention",
  "已开启 · 待上传 {count} 条": "Enabled · {count} pending uploads",
  "待上传 {count} 条": "{count} pending uploads",
  "本机接入：{status}": "Local connection: {status}",
  "云端上传：{status}": "Cloud uploads: {status}",
  "将账号「{account}」在团队「{team}」下未暂停、未排除的本地记录及后续输入输出上传，团队成员可见。排队请求暂不上云。": "Upload existing and future inputs and outputs for account “{account}” in team “{team}”, except paused or excluded records. Team members can see them. Queued requests stay local.",
  "查看接入指令": "View connection instructions",
  "仅在 Arkme 确认开启云端上传后，指定团队中未暂停、未排除的已有记录及后续输入输出才会上传，团队成员可见。排队请求、Token 用量暂不上传；删除本地记录不会删除云端副本。": "Only after you enable cloud uploads in Arkme will existing and future eligible inputs and outputs be shared with the selected team. Paused and excluded records, queued requests and token usage are not uploaded. Deleting local records does not delete cloud copies.",
  "账号：{name} · @{id}": "Account: {name} · @{id}",
  "团队：{name} · @{id}": "Team: {name} · @{id}",
  "任意 Codex 对话粘贴一次，后续本机各项目、任务自动采集（排除项除外）。": "Paste once in any Codex conversation to collect future activity across this computer’s projects and tasks, except exclusions.",
  "每位成员、每台采集电脑需自行生成指令，请勿转发。仅查看云端记录无需接入采集。": "Generate instructions separately for each member and collection computer. Do not forward them. Viewing cloud records does not require local collection.",
  "接入说明": "Connection details",
  "需本机安装 Python 3；保持 Arkme 运行并登录绑定账号。先审查脚本，再在 Codex 确认信任 Hooks；已有会话可能需要恢复或重启。收到真实事件才显示本机已连接。": "Python 3 is required. Keep Arkme running and signed into the bound account. Review the script and approve Hook trust in Codex; existing conversations may need to resume or restart. A real event is required to confirm the local connection.",
  "只采集接入后的新输入、最终回答和中断状态，不读取此前历史。首次指令有效期不影响已完成的接入；云端上传授权需在 Arkme 单独确认。": "Only new inputs, final answers and interruptions are collected; earlier history is not read. Initial instruction expiry does not expire an established connection. Cloud uploads require separate confirmation in Arkme.",
  "接入本机后，新的工作动态会显示在这里。": "Connect this computer to see new work activity here.",
  "开启上传后，指定团队成员可跨电脑查看；仅查看云端记录无需接入本机 Codex。": "After uploads are enabled, members of the selected team can view activity across computers. Viewing cloud records does not require connecting local Codex.",
  "团队任务与对话": "Team tasks and conversations",
  "我的任务与对话": "My tasks and conversations",
  "团队工作台": "Team workspace",
  "回到我的任务": "My tasks",
  "Codex 对话": "Codex conversations",
  "团队列表未完整加载，请重试": "The team list could not be fully loaded. Try again.",
  "查看成员任务，管理团队同步。不会改变当前上传设置。": "View member tasks and manage team sync. Viewing does not change upload settings.",
  "部分来源暂不可用：{teams}，当前仅显示可读取的记录。": "Some sources are unavailable: {teams}. Only accessible records are shown.",
  "暂无自己的同步任务": "No synced tasks of your own yet",
  "这里展示自己已同步的任务。接入与同事任务请前往团队工作台。": "Your synced tasks appear here. Open the team workspace for setup and colleagues’ tasks.",
  "管理任务：{title}": "Manage task: {title}",
  "切换 Codex 任务": "Switch Codex task",
  "选择任务": "Choose a task",
  "团队与同步管理": "Team and sync settings",
  "返回团队": "Back to team",
  "查看团队": "View team",
  "仅切换查看范围，不改变同步团队": "Changes viewing scope only, not the upload destination",
  "选择团队": "Choose a team",
  "更多团队": "More teams",
  "Codex 团队对话": "Codex team conversations",
  "团队加载失败": "Unable to load teams",
  "查看团队的 Codex 对话": "View your team's Codex conversations",
  "先选择团队，再查看自己或成员的任务。此选择不会改变上传设置。": "Choose a team to view your or other members' tasks. This does not change upload settings.",
  "暂无可查看的团队，请先在联系人中创建或加入团队。": "No teams available. Create or join a team in Contacts first.",
  "输入下一条需求": "Enter the next request",
  "输入下一条需求…": "Enter the next request…",
  "加入队列": "Add to queue",
  "仅本机验证": "Local testing only",
  "本机助手尚未就绪，暂不能派发": "The local helper is not ready to dispatch requests",
  "请先在本机助手开启自动输入": "Enable automatic input in the local helper first",
  "这项任务来自其他电脑，云端派发尚未接通": "This task is on another computer. Cloud dispatch is not available yet",
  "当前账号、团队或任务暂不允许派发": "Dispatch is unavailable for this account, team or task",
  "连接助手": "Connect helper",
  "重试保存": "Retry saving",
  "等待 Codex 草稿处理，不会覆盖原文": "Waiting for the Codex draft to be handled; it will not be overwritten",
  "等待来源电脑解锁": "Waiting for the source computer to unlock",
  "等待本机助手授权": "Waiting for helper authorization",
  "等待本机空闲，不打断正在输入": "Waiting for local activity to stop; typing will not be interrupted",
  "等待 Codex 可用": "Waiting for Codex to become available",
  "等待核对目标对话": "Waiting to verify the target conversation",
  "等待助手恢复": "Waiting for the helper to recover",
  "等待本机助手处理": "Waiting for the local helper",
  "已保存到本机，等待派发": "Saved locally; waiting for dispatch",
  "正在检查本机状态": "Checking the source computer",
  "正在提交，尚未确认入队": "Submitting; queue entry is not confirmed yet",
  "Codex 已加入队列": "Queued in Codex",
  "Codex 已接受": "Accepted by Codex",
  "送达结果待确认，不会自动重发": "Delivery is unconfirmed; it will not be retried automatically",
  "已停止派发": "Dispatch stopped",
  "请求已过期，未派发": "Request expired without dispatch",
  "保存结果待确认；重试会核对同一请求，不会重复派发": "Saving is unconfirmed. Retry checks the same request without dispatching it twice",
  "提交时会短暂切换来源电脑的 Codex 窗口": "Submission briefly switches to Codex on the source computer",
  "助手派发功能接入中，暂不可发送": "Helper dispatch is being integrated. Sending is not available yet",
  "仅查看成员对话，不开放操作对方电脑": "Member conversations are read-only. Their computers cannot be controlled",
  "连接 Codex 助手": "Connect Codex helper",
  "无需修改 Arkme 客户端。后续由独立安装的本机助手，代你向 Codex 输入需求并加入队列。": "No Arkme client changes are required. A separately installed local helper will enter and queue requests in Codex.",
  "安装并打开独立助手": "Install and open the standalone helper",
  "当前验证版尚未接通 Arkme 接单，暂不提供正式安装入口。": "The preview helper cannot receive Arkme requests yet. A release installer is not available.",
  "为助手授予系统控制权限": "Grant the helper system control permission",
  "在 macOS「隐私与安全」中的「设备控制和数据访问」（旧版为「辅助功能」）授权助手，而不是 Arkme 客户端。": "Authorize the helper, not Arkme, in macOS Privacy & Security under Device Control and Data Access (Accessibility on older versions).",
  "确认账号、团队与来源电脑，开启自动输入": "Confirm the account, team and source computer, then enable automatic input",
  "同步记录不等于授权操作；执行时会短暂切换到 Codex，锁屏或存在草稿时等待。": "Syncing records does not authorize control. Submission briefly switches to Codex and waits if the screen is locked or a draft is present.",
  "当前入口不会创建请求、发送消息或更改系统权限。": "This entry point does not create requests, send messages or change system permissions."
}
